import { render, staticRenderFns } from "./PlayLevel.vue?vue&type=template&id=715e8d56&"
import script from "./PlayLevel.vue?vue&type=script&lang=js&"
export * from "./PlayLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports